import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.kiosk.print');
import { OnInit, Input } from "@angular/core";
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-kiosk-print',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.kiosk.print/view.scss */
/* src/app/portal.kiosk.print/view.scss: no such file or directory */`],
})
export class PortalKioskPrintComponent implements OnInit {
    @Input() event: any;
    @Input() opts: any;

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        this.result = this.event.get("result");
        await this.service.render();
        await this.start();
    }

    public url() {
        let bg = this.event.get("bg");
        return wiz.url("result" + bg);
    }

    public async start() {
        await wiz.call("printer", { data: JSON.stringify(this.result) });
        await this.event.view("final");
    }
}

export default PortalKioskPrintComponent;